<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>{{ enviarCorreoText }}</h3>
            </div>
        </div>
        <div class="card">
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="form-field">
                            <input-field v-model="form.correos" id="correosCliente" :placeholder="$t('message.placeholderCorreo')">
                                {{ $t('message.email') }}
                                <span v-if="errores.correos" class="helper-text text-danger" slot="helper">
                                    <strong>{{ errores.correos[0] }}</strong>
                                </span>
                            </input-field>
                        </div>
                        <div class="form-field select">
                            <div class="select-field">
                                <select name="tipo" v-model="form.tipo" id="tipo">
                                    <option value="in">IN</option>
                                    <option value="out">OUT</option>
                                </select>
                                <label for="tipo">Tipo de EIR</label>
                            </div>
                        </div>
                        <div class="form-field select">
                            <div class="select-field">
                                <select name="proceso" v-model="form.proceso" id="proceso">
                                    <option value="C">Caja</option>
                                    <option value="M">Máquina</option>
                                </select>
                                <label for="proceso">Proceso</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button @click="enviarCorreo" class="btn-success" type="button"><i class="fa fa-envelope"></i><span>{{ $t('message.enviarCorreo') }}</span></button>
            <button @click="cancelar" class="btn-danger btn--text"><i class="fa fa-ban"></i><span>{{ $t('message.cancelar') }}</span></button>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        secuencia : {
            required : false,
            default : undefined
        },
        tipo : {
            type : String,
            required : false,
            default : 'in'
        },
        correosCliente : {
            type : String,
            required : false,
            default : ''
        },
        number : {
            type : String,
            required : true
        },
        avisoText : {
            type : String,
            required : false,
            default : 'Aviso'
        },
        errorValidationText : {
            type : String,
            required : false, 
            default : 'Error de validación'
        },
        errorText : {
            type : String,
            required : false,
            default : 'Hubo un error, intente nuevamente.'
        },
        requiredEmailText : {
            type : String,
            required : false,
            default : 'Se requiere de al menos una dirección de correo electrónico.'
        },
        emailsSent : {
            type : String,
            required : false,
            default : 'Los correos fueron enviados exitósamente.'
        },
        enviarCorreoText : {
            type : String,
            required : false,
            default : 'Enviar EIR por correo'
        },
        labelEmail : {
            type : String,
            required : false,
            default : 'Correo(s) (Separados por coma)'
        },
        cancelarText : {
            type : String,
            required : false,
            default : 'Cancelar'
        }
    },
    methods : {
        enviarCorreo : function () {
            let that = this;
            if (this.form.correos !== '') {
                
                axios.post(this.url + '/eir', this.form).then(function (response) {
                    swal(that.$t('message.correoEnviado'), that.$t('message.aviso'), 'success');
                    that.$emit('enviado');
                }).catch(function (error) {
                    if (error !== undefined && error !== null) {
                        let response = error.response;
                        if (response !== undefined && response !== null) {
                            let status = response.status;
                            if (status === 422) {
                                that.errores = response.data.errors;
                                swal(that.$t('message.errorValidacion'), that.$t('message.aviso'), 'warning');
                            }
                            else 
                                swal(that.$t('message.errorText'), that.$t('message.error'), 'error');
                        }
                    }
                });
            }
            else 
                swal(that.$t('message.emailRequerido'), that.$t('message.aviso'), 'warning');
        },
        cancelar : function () {
            this.$emit('cancelar');
        }
    },
    data : function () {
        return {
            form : {
                correos : this.correosCliente,
                number : this.number,
                tipo : this.tipo,
                secuencia : this.secuencia,
                proceso: 'C'
            },
            url : url,
            errores : {}
        };
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/clientes/EnviarEir.vue